export default "__VITE_ASSET__a13297cf__"